import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleUserSubscribe } from '../../actions/toggle-user-subscribe';
import FollowUserButton from '../../components/follow-user-button';
import ensureAuth from '../../hoc/ensure-auth';

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      onClick: () => toggleUserSubscribe(ownProps.user._id),
    },
    dispatch
  );

export default _.flowRight(connect(undefined, mapDispatchToProps), ensureAuth)(FollowUserButton);



// WEBPACK FOOTER //
// ./app/containers/follow-user-button-secure/follow-user-button-secure.js